import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';

function DocumentClaimsHit({ claimsText, closeClick, trackingAttrs }) {
  const claimsHit = DocumentHitsFormat.checkAndFormatHit(claimsText, 'claims');

  return claimsHit ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      {...trackingAttrs}
      className="result-detail-panel u-els-margin-top-1o2 e2e-document-action-claims-hit"
      onClick={closeClick}
      role="button"
      tabIndex="0"
      aria-label="Claims hit">
      <div className="result-detail-panel-wrapper">
        <h4 className="u-els-margin-bottom-1o2">Claims hit:</h4>
        <InnerHTML tag="div" className="result-detail-block u-els-font-size-base u-els-line-height-default" html={claimsHit} />
        <svg className="els-btn-icon svg-icon els-btn-icon-sm collapsable-section-chevron">
          <use xlinkHref="#icon-chevron-down" />
        </svg>
      </div>
    </div>
  ) : null;
}

DocumentClaimsHit.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
  // for analytics
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentClaimsHit;
